const USERSVIEW = {
  listUsers: "user list",
  updateUser: "Update user",
  newUser: "New user",
  search: "Search",
  headTable: {
    user: "User",
    email: "Email",
    phone: "Phone",
    company: "Company",
    rol: "Rol",
    state: "State",
    actions: "Actions"
  },
  dropdowm: {
    update: "To update",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    eliminated: "Eliminated"
  },
  confirmActive: {
    title: "Confirmation",
    text: `You want to activate the user {name} {lastname}`
  },
  deleteUser: {
    title: `Delete User: {email}`,
    text: `Are you sure you want to delete the user?`,
    acceptText: "Accept",
    cancelText: "Cancel"
  },
  deleteItemError: {
    title: "Delete Users",
    text: "An error occurred while deleting the user",
    acceptText: "Accept",
    cancelText: "Cancel"
  },
  state: {
    active: "Active",
    inactive: "Inactive",
    removed: "Removed",
    Active: "Active",
    Inactive: "Inactive"
  },

  formEditUser: {
    name: "Names",
    lastName: "Surnames",
    email: "Contact email",
    address: "Address",
    rol: "rol",
    deparment: "Department",
    city: "City",
    company: "Company",
    languages: "Language (locale)",
    password: "Password",
    repeatPass: "Repeat the password",
    status: "Status"
  },
  btn: {
    clean: "Clean up",
    create: "To create",
    update: "To update"
  },
  assignForm: {
    title: "Assign Forms",
    name: "Name/Activity",
    type: "Type",
    group: "Group",
    created: "Created",
    state: "State"
  },
  BOT: {
    searchBot: "Search form bot...",
    searchUser: "Search user",
    title: "Forms",
    selectAll: "Select all",
    created: "Created",
    titleNotify: "Assignment",
    message1: "The forms have been assigned to the user(s)",
    messageError: "Form mapping error"
  }
};

export default { USERSVIEW };
